// src/utils/emailValidatorMixin.js - Versão Vue 3
import { reactive } from 'vue';
import EmailValidator from '@/utils/EmailValidator';

export default {
  data() {
    return {
      emailErros: reactive({})
    }
  },
  methods: {
    validarEmailGeneric(email, fieldId, options = {}) {
      
      // eslint-disable-next-line no-debugger
      debugger

      // Opções padrão
      const opts = {
        focarNaFalha: true,
        salvarErro: true,
        emailComparacao: null,
        mensagemEmailsIguais: 'Os e-mails não podem ser iguais.'
      };

      // Mescla as opções
      Object.assign(opts, options);
      
      // Resetar o erro
      this.emailErros[fieldId] = '';
      
      // Se estiver vazio
      if (!email || email.trim() === '') {
        if (options.obrigatorio) {
          const mensagem = options.mensagemObrigatorio || 'Campo obrigatório.';
          this.emailErros[fieldId] = mensagem;
          
          // Para compatibilidade com seu código atual
          if (fieldId === 'emailSecundario') {
            this.mensagemErro = mensagem;
          }
          
          if (opts.focarNaFalha) {
            this.focarCampo(fieldId);
          }
          return false;
        }
        return true;
      }

      const resultadoValidacao = EmailValidator.validar(email);
      
      if (!resultadoValidacao.valido) {
        if (opts.salvarErro) {
          this.emailErros[fieldId] = resultadoValidacao.mensagem;
        }
        if (opts.focarNaFalha) {
          this.focarCampo(fieldId);
        }
        return false;
      }

      if(options.emailComparacao != '' && options.emailComparacao != null)
      {
        var resultadoValidacaoComparar = EmailValidator.compararEmails(email, options.emailComparacao);
        if (resultadoValidacaoComparar.iguais) {
          if (opts.salvarErro) {
            this.emailErros[fieldId] = resultadoValidacaoComparar.mensagem;
          }
          if (opts.focarNaFalha) {
            this.focarCampo(fieldId);
          }
          return false;
        }
      }
      
      // Se passou por todas as validações
      return true;
    },
    
    /**
     * Foca um campo pelo ID
     */
    focarCampo(id) {
      const input = document.getElementById(id);
      if (input) {
        input.focus();
      }
    }
  }
}